<template>
  <span :class="[status.toLowerCase(), objectType]" class="status">
    <font-awesome-icon :icon="iconName" />
    {{ $t(`statuses.${status.toLowerCase()}`) }}
  </span>
</template>

<script>
export default {
  name: 'Status',
  props: {
    status: {
      type: String,
      required: true
    },
    objectType: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName() {
      switch (this.status.toLowerCase()) {
        case 'draft':
          return 'pencil-alt';

        case 'submitted':
          return 'arrow-right';

        case 'approved':
          return 'check';

        case 'received':
          return 'inbox';

        case 'active_online':
        case 'active_offline':
        case 'processed':
          return 'check-double';

        case 'rejected':
          return 'times';

        case 'obsolete':
          return 'ban';

        case 'finished':
          return 'stop-circle';

        case 'cancelled':
          return 'stop-circle';

        default:
          return 'circle';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';

.status {
  border: 1px solid;
  border-radius: 28px;
  padding: 5px 10px;
  font-weight: bold;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;

  &.draft {
    color: $grey;
    border-color: $grey;
  }
  &.submitted {
    color: $orange;
    border-color: $orange;
  }
  &.approved,
  &.active_online,
  &.active {
    color: $green;
    border-color: $green;
  }
  &.approved.assignment,
  &.finished,
  &.completed {
    color: $blue;
    border-color: $blue;
  }
  &.received,
  &.active_offline,
  &.inactive {
    color: $purple;
    border-color: $purple;
  }
  &.processed,
  &.reconciled {
    color: $blue;
    border-color: $blue;
  }
  &.rejected,
  &.obsolete {
    color: $red;
    border-color: $red;
  }
}

.header-title .status {
  vertical-align: top;
  margin-left: 2em;
}

@media print {
  .status {
    padding: 3px 8px;
  }
}
</style>
